import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { CreditBox } from 'app/models/dto/credit-box.model';
import { CreditBoxesService } from 'app/services/credit-boxes/credit-boxes.service';
import { GetCreditBoxes } from './credit-boxes.actions';
import { take, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

export class CreditBoxesStateModel {
  creditBoxes: CreditBox[];
}

@State<CreditBoxesStateModel>({
  name: 'creditBoxes'
})

@Injectable()

export class CreditBoxesState {
  @Selector()
  static creditBoxes(state: CreditBoxesStateModel) {
    return state.creditBoxes;
  }

  constructor(
    private creditBoxesService: CreditBoxesService
  ){}

  @Action(GetCreditBoxes)
  getCreditBoxes({patchState}: StateContext<CreditBoxesStateModel>, {}: GetCreditBoxes) {
    this.creditBoxesService.getCreditBoxes()
      .subscribe((creditBoxes: CreditBox[]) => {
        patchState({
          creditBoxes: creditBoxes
        });
      });
  }
}

